(function () {
  "use strict";

  /* Budget build (2026-08-20): the Wilton SERVINGS table, units helpers,
     cake renderer, stack enumerator, pan wall and scoped-save flow moved
     VERBATIM to the shared core asset (learn-cake-core.js, loaded before
     this file, exposed as window.LAYERD.cakeCore) so Serving and the
     Pricing budget section run ONE engine. This file is a consumer — the
     locals below are aliases; behaviour is unchanged. */
  var CORE = window.LAYERD && window.LAYERD.cakeCore;

  var root = document.getElementById('ldcCakeCalc');
  /* every viewport move routes through the ONE shared utility
     (nav rule 2026-07-20); absent = no scroll, never a local fallback */
  function ldNav(target, opts) {
    var C2 = window.LAYERD && window.LAYERD.components;
    return !!(C2 && C2.navigateToSection && C2.navigateToSection(target, opts));
  }

  if (!root) return;
  if (!CORE) {
    /* absent core (deploy-order slip, blocked asset): the tool says so and
       stops — never a silent half-render. */
    var coreFail = document.createElement('p');
    coreFail.className = 'ldc-error';
    coreFail.textContent = 'The calculator couldn’t load fully, please refresh the page.';
    root.insertBefore(coreFail, root.firstChild);
    return;
  }

  var SERVINGS = CORE.SERVINGS;
  var SHAPE_LABEL = CORE.SHAPE_LABEL;
  var ROUND_SIZES = CORE.ROUND_SIZES;
  var UNITS_KEY = CORE.UNITS_KEY;               /* 'layerd-learn-units' */
  var unitPref = CORE.unitPref;
  var sizeLabel = CORE.sizeLabel;
  var OTHER_DESSERTS_FACTOR = 0.8; // mid-point of the commonly cited 75-85% planning range

  /* ============================================================
     r99 (Mariya, 2026-08-25) — INFO NOTES that actually open.
     "The question mark info note beside 'other desserts will also
     be served' doesn't work." It was a native title= tooltip: on a
     phone those never open at all, and the installed app is where
     she works. The mark is a real button now, and its note opens
     in place, under the thing it explains. The Wilton serving-basis
     paragraph that used to sit in the page footer becomes the same
     kind of note, tied to "Target servings" where the number it
     qualifies actually appears.
     Copy lives in data-infotext so the note has one source.
     ============================================================ */
  function escAttr(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function infoBtnHtml(text, aria) {
    if (!text) return '';
    return '<button type="button" class="ldc-info" aria-expanded="false" aria-label="' +
      escAttr(aria || 'What this means') + '" data-infotext="' + escAttr(text) + '">i</button>';
  }
  function toggleInfo(btn) {
    var open = btn.getAttribute('aria-expanded') === 'true';
    var note = btn._ldNote;
    if (!note) {
      note = document.createElement('div');
      note.className = 'ldc-infonote';
      note.textContent = btn.getAttribute('data-infotext') || '';
      var host = btn.closest('.ldc-check') || btn.closest('.ld-result') ||
                 btn.closest('.ldc-heroresult') || btn.closest('.ldc-field') || btn.parentNode;
      host.appendChild(note);
      btn._ldNote = note;
    }
    note.hidden = open;
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
  }
  root.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.ldc-info') : null;
    if (!b) return;
    ev.preventDefault();
    toggleInfo(b);
  });
  /* the template's old (?) marks, converted in place, title removed so no
     half-working native tooltip survives alongside the real one */
  Array.prototype.forEach.call(root.querySelectorAll('.ldc-tip[title]'), function (t) {
    var holder = document.createElement('span');
    holder.innerHTML = infoBtnHtml(t.getAttribute('title'));
    var b = holder.firstChild;
    if (b && t.parentNode) t.parentNode.replaceChild(b, t);
  });
  /* the Wilton basis: read the footer paragraph once, retire it from the
     foot, and hand its words to the note beside Target servings */
  var WILTON_NOTE = '';
  (function () {
    var d = document.getElementById('ldc-serving-count');
    if (!d) return;
    WILTON_NOTE = (d.textContent || '').replace(/\s+/g, ' ').trim();
    d.hidden = true;
  })();
  /* item 4 (Mariya): "How many tiers do you prefer for the final look?" is
     a mouthful mid-form. Retexted here so the fix ships with the asset —
     the template carries the same words for the next rebuild. */
  Array.prototype.forEach.call(root.querySelectorAll('label[for="ldcGuestTiers"], label[for="ldcBudgetTiers"]'), function (l) {
    l.textContent = 'How many tiers for this cake?';
  });

  /* Learn sub-nav: keep the active tab visible when the row scrolls on
     small screens (same behaviour as the hub's learn-subnav.js). */
  (function () {
    var row = root.querySelector('.learn-subnav__row');
    if (!row) return;
    var active = row.querySelector('[aria-current="page"]');
    if (!active) return;
    var max = row.scrollWidth - row.clientWidth;
    if (max <= 0) return;
    var tabLeft = active.getBoundingClientRect().left
                - row.getBoundingClientRect().left + row.scrollLeft;
    var target = tabLeft - (row.clientWidth - active.offsetWidth) / 2;
    if (target < 0) target = 0;
    if (target > max) target = max;
    row.scrollLeft = target;
  })();
  var state = {
    mode: 'guests',  /* guests first + default (Mariya, 2026-07-29 —
                        reverses her 2026-07-09 call: in the installed
                        app the first question is the client's, and the
                        client knows a headcount, not pan sizes) */
    occasion: 'wedding', // shared: 'wedding' | 'party'
    guestHeight: 4,      /* internal only since 2026-07-29, the height
                            SELECT is gone (suggestions explore every
                            height themselves); 4" remains the tie-break
                            and the fallback for pre-change snapshots */
    guestTiers: 0,       // mode 1: preferred tier count for the final look; 0 = no preference
    budgetBand: 'simple',   /* mode 3 (Budget build 2026-08-21): base cover */
    budgetTiers: 0          // mode 3: preferred tier count; 0 = no preference
  };

  /* ---------------------------- helpers ---------------------------- */

  /* Toolkit Fix 02 P1-9 / 2026-09-14: the slice standard is explained ONCE.
     It used to be a page-bottom paragraph the in-form hint anchored down to;
     the brief moves it behind the "?" popover the results already use. The
     #ldc-serving-count paragraph stays in the DOM (hidden) purely as the text
     source for WILTON_NOTE; the hint now carries its own "?" instead of a jump. */
  function sliceHintHtml() {
    return 'Taller tiers = more slices' + infoBtnHtml(WILTON_NOTE, 'How servings are counted');
  }

  function updateSliceHints() {
    /* r54 follow-up (Mariya): the "how servings are counted" line is retired
       from both panels - the link led to the footer note that is now folded
       behind the info "i" beside the result, so the line was a dead redundant
       jump. The "i" carries the same Wilton basis where the number appears. */
    var h1Old = document.getElementById('ldcSliceHint');
    if (h1Old) h1Old.hidden = true;
    var h2 = document.getElementById('ldcSliceHint2');
    if (h2) h2.hidden = true;
  }

  /* the fixed-slice height rule + servingsFor() live in the core now */
  var STD_SLICE_HEIGHT = CORE.STD_SLICE_HEIGHT;
  var servingsFor = CORE.servingsFor;

  // RETIRED 2026-07-17 (Mariya: fewer words — the pipeline bar and the
  // start-a-file lead own "what's next" on this page now). No call sites.
  function bridgeLines(tiers, occasion) {
    var html = '';
    var tall = tiers.some(function (t) { return (t.height || STD_SLICE_HEIGHT) >= 6; });
    if (tall || tiers.length >= 3) {
      html += '<p class="ldc-bridge">' +
        (tall ? 'Tall tiers need real support inside' : 'Three or more tiers need real support inside') +
        '. <a href="/pages/structure">Check your build in the Structure tool</a>.</p>';
    }
    if (occasion === 'wedding' && tiers.length >= 2) {
      html += '<p class="ldc-bridge">Planning the week around this cake? <a href="/pages/planner">The Planner maps it all backwards from delivery day</a>.</p>';
    }
    return html;
  }

  /* THE CAKE RENDERER lives in the core now (learn-cake-core.js) —
     same pure function, same drawing, one implementation. */
  var renderStack = CORE.renderStack;

  /* the shared result furniture (YOUR CAKE card + per-tier legend) is the
     core's too — the budget section renders the same cards */
  var cakeCardHtml = CORE.cakeCardHtml;
  var legendHtml = CORE.legendHtml;

  /* r191: THE PRINTED SERVING PLAN reads what we just drew, so the paper
     and the screen can never disagree. This file already computed every
     number the sheet needs; it simply never published any of them.
     learn-serving-plan.js is the only consumer, and it soft-fails if this
     is absent — nothing here depends on it existing.

     `target` is the SERVING target and `guests` the headcount behind it.
     They are the same number until "other desserts are served" is ticked,
     which sets the target to 85% of the headcount — the sheet has to say
     both, because "a guest count of 85" for a 100-guest wedding would be a
     lie on a client's paper. Tiers mode has neither. */
  function publishPlan(tiers, total, target, guests) {
    window.LAYERD = window.LAYERD || {};
    window.LAYERD.servingPlan = {
      tiers: tiers,
      total: total,
      target: (+target > 0) ? +target : null,
      guests: (+guests > 0) ? +guests : null,
      occasion: state.occasion
    };
  }

  /* ======================= MODE TOGGLE ======================= */

  var modeBtns = root.querySelectorAll('.ldc-mode-btn');
  var guestsPanel = document.getElementById('ldcGuestsPanel');
  var tiersPanel = document.getElementById('ldcTiersPanel');
  var leadCard = document.getElementById('ldcLeadCard');

  modeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      modeBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      state.mode = btn.getAttribute('data-mode');
      guestsPanel.hidden = state.mode !== 'guests';
      tiersPanel.hidden = state.mode !== 'tiers';
      /* Budget build (2026-08-21): the third mode */
      if (budgetPanel) budgetPanel.hidden = state.mode !== 'budget';
      leadCard.hidden = true;
      /* r46: the print row follows the results' visibility, so a mode
         switch (which clears them) hides it again until the next render */
      var pr = document.getElementById('ldcPrintRow');
      if (pr) pr.hidden = true;
    });
  });

  /* ======================= OCCASION TOGGLES (shared state, two UIs) ======================= */

  /* r152 (Mariya: "still getting 28 on pricing instead of 26"). r151 made
     occasion a booking field and sent it on SAVE - but the pill itself
     wrote nothing, so flipping to Party and walking to Pricing left the
     file saying 'wedding'. How a cake is sliced is a FACT about the cake,
     not a local preference: the moment she taps it, it is written. */
  function ldcPaintOccasion() {
    root.querySelectorAll('.ld-chip[data-occasion]').forEach(function (b) {
      var active = b.getAttribute('data-occasion') === state.occasion;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });
    updateSliceHints();
  }
  function ldcSaveOccasionToFile() {
    /* scoped only - with no client file the pills stay local state and
       the scratch slot picks the value up on the next save */
    if (!servingBooking || !window.LdCakeFile || !window.LdCakeFile.writeOccasion) return;
    try { window.LdCakeFile.writeOccasion(state.occasion, 'serving'); } catch (e) { }
  }
  function ldcSyncOccasionFromFile() {
    if (!servingBooking || !window.LdCakeFile || !window.LdCakeFile.readCake) return;
    var occ = null;
    try {
      var rc = window.LdCakeFile.readCake();
      if (rc && rc.meta && rc.meta.occasion) occ = rc.meta.occasion;
    } catch (e) { return; }
    if (occ !== 'party' && occ !== 'wedding') return;
    if (occ === state.occasion) return;
    state.occasion = occ;
    ldcPaintOccasion();
  }
  function wireOccasionSegment(container) {
    var btns = container.querySelectorAll('.ld-chip');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.occasion = btn.getAttribute('data-occasion');
        ldcPaintOccasion();          /* both segmented controls at once */
        ldcSaveOccasionToFile();     /* r152: the fact, not a preference */
        /* always-live: occasion changes the recommended stack / slice counts,
           so re-run the active mode's result immediately */
        if (state.mode === 'guests' && typeof computeGuests === 'function') computeGuests(true);
        else if (state.mode === 'tiers' && typeof computeTiers === 'function') computeTiers(true);
        else if (state.mode === 'budget' && typeof regenerateBudget === 'function') regenerateBudget();
      });
    });
  }
  root.querySelectorAll('.ld-chips').forEach(wireOccasionSegment);
  /* the file is the source of truth on load, and when another tool moves it.
     DEFERRED on purpose: `servingBooking` is assigned ~1000 lines below
     this point, and `var` hoists the NAME, not the value - calling it
     inline would read `undefined`, take the unscoped early-return and
     silently never seed. setTimeout(0) runs after this IIFE completes,
     by which time the booking is resolved. (Same trap as the SEEN_KEY
     hoisting bug in Pricing.) */
  setTimeout(ldcSyncOccasionFromFile, 0);
  window.addEventListener('layerd:cakefile', function (e) {
    var d = (e && e.detail) || {};
    if (d.source === 'serving') return;   /* our own write, already painted */
    ldcSyncOccasionFromFile();
  });
  updateSliceHints();

  /* ======================= MODE 1: GUEST COUNT -> RECOMMENDATION ======================= */

  /* the 2-3″ step-down rule, the P3-4 pan wall, the enumerator and the
     P3-5 double-barrel badge live in the core now — the P3-4 history
     comment travelled with them (see learn-cake-core.js). */
  var MIN_TIER_GAP = CORE.MIN_TIER_GAP;
  var MAX_TIER_GAP = CORE.MAX_TIER_GAP;
  var ownedPans = CORE.ownedPans;
  var offPanCount = CORE.offPanCount;
  var generateCombos = CORE.generateCombos;
  var DBARREL_FROM = CORE.DBARREL_FROM;
  var dbarrelHtml = CORE.dbarrelHtml;

  /* SPINE 2026-09-06: the guest-count search moved VERBATIM into cake-core
     (CORE.recommendStack) so the Studio's Size step and this page run ONE
     engine. This is now a thin delegate — same inputs, byte-identical output.
     Heights are still page-owned (GUEST_HEIGHTS), passed through. */
  /* r223 (Mariya): the chosen shape for each reverse-search mode. Defaults to
     round; only round/square/heart are valid. */
  function guestShape() {
    var e = document.getElementById('ldcGuestShape');
    var v = e && e.value;
    return (v === 'square' || v === 'heart') ? v : 'round';
  }
  function budgetShape() {
    var e = document.getElementById('ldcBudgetShape');
    var v = e && e.value;
    return (v === 'square' || v === 'heart') ? v : 'round';
  }
  /* the shape a reverse-search result should carry, by the active mode */
  function searchShape() { return state.mode === 'budget' ? budgetShape() : guestShape(); }
  function recommendCombos(targetGuests, occasion, prefTiers) {
    return CORE.recommendStack(targetGuests, occasion, {
      prefTiers: prefTiers,
      heights: GUEST_HEIGHTS.map(function (g) { return g[0]; }),
      shape: guestShape()
    });
  }

  /* The heights the recommendation engine explores (uniform per stack).
     Since 2026-07-29 this is engine-internal only — the "How tall are
     your tiers?" select was retired (the tool owns heights; the baker
     steers the LOOK via the tier-count preference below). */
  /* P3-4: the pan-wall setting. Chips over every round size the tool knows;
     the stored list re-ranks suggestions and nothing else. Written once,
     read by ownedPans() on every search. */
  /* the pan-wall UI is the core's now (one implementation, one store) —
     this page hands it its mounts and the search re-run hook. */
  CORE.wirePanWall({
    box: document.getElementById('ldcPans'),
    now: document.getElementById('ldcPansNow'),
    reset: document.getElementById('ldcPansReset'),
    onChange: function () { regenerateGuests(); }
  });
  /* r74 (Mariya's test user: "had no idea it was there"): the pans fold is
     set-once-and-forgotten by design, but a FIRST visit collapsed it into
     one easily-scrolled-past line, and the standard set silently ranked
     the results. First visit ever, every pans fold on the page ships OPEN
     with its chips in view; any interaction with it — or running a search,
     which means it was seen open — collapses it for good. */
  (function pansFirstVisit() {
    var K = 'layerd-pans-seen';
    var seen = null;
    try { seen = localStorage.getItem(K); } catch (e) { }
    if (seen) return;
    var folds = document.querySelectorAll('.ldc-pansfold');
    Array.prototype.forEach.call(folds, function (f) { f.open = true; });
    function done() {
      try { localStorage.setItem(K, '1'); } catch (e) { }
      Array.prototype.forEach.call(folds, function (f) { f.open = false; });
      document.removeEventListener('click', watch, true);
    }
    function watch(ev) {
      var t = ev.target;
      if (!t) return;
      /* touching the fold itself keeps it open this visit but marks seen;
         a calculate collapses it too — they saw it open above the button */
      if (t.closest && t.closest('.ldc-pansfold')) {
        try { localStorage.setItem(K, '1'); } catch (e) { }
        document.removeEventListener('click', watch, true);
        return;
      }
      if (t.closest && t.closest('#ldcCalcGuestsBtn, #ldcCalcBtn, #ldcCalcBudgetBtn')) done();
    }
    document.addEventListener('click', watch, true);
  })();

  /* r223 (Mariya: "I don't see any 4" options ... is it considering shorter
     tier options?"). The engine explored 4"-8" only; now that 3" is a real
     build height on the page, it belongs in the search too, so a flatter cake
     can be offered where one serves the count. 4" still leads every tie (the
     sort below prefers height 4, then the nearest to it), so 3" surfaces only
     as a "shorter tiers" alternative, never ahead of a standard build. */
  var GUEST_HEIGHTS = [[3, ''], [4, ''], [5, ''], [6, ''], [7, ''], [8, '']];
  var guestTiersSel = document.getElementById('ldcGuestTiers');
  if (guestTiersSel) {
    guestTiersSel.addEventListener('change', function () {
      state.guestTiers = parseInt(guestTiersSel.value, 10) || 0;
      /* re-run visible results so the preference lands immediately */
      var results = document.getElementById('ldcGuestsResults');
      if (results && !results.hidden) computeGuests(true);
    });
  }
  /* r223: shape change re-runs the search on the chosen shape */
  var guestShapeSel = document.getElementById('ldcGuestShape');
  if (guestShapeSel) {
    guestShapeSel.addEventListener('change', function () {
      var results = document.getElementById('ldcGuestsResults');
      if (results && !results.hidden) computeGuests(true);
    });
  }

  /* which of the suggested combos is "my cake" — recommended by default */
  var lastGuestCombos = null, chosenComboIdx = 0;
  /* r99: has she actually CHOSEN a stack yet? Until she does, the headline
     card is the studio's recommendation, not "your cake". */
  var guestPicked = false, budgetPicked = false;

  /* r17 (Mariya, 2026-07-31): "it will be default selecting the first
     option ... but then it won't let me go next until I select a cake even
     though it makes it appear like I've already selected the default."
     She is right, and the old comment below ("starts selected AND saved")
     was only true for anonymous work: unscoped, the recommendation really
     is written to the scratch cake, so showing it ticked is honest. With a
     CLIENT FILE open nothing is written until she picks one - yet the card
     still rendered "✓ Your cake", so the page claimed a save that had not
     happened and the Next button had nothing to advance to.
     The tick now follows the FILE, not the render. */
  /* S-4 (2026-08-03): a logged-in member is never asked for the email
     address they signed up with. The card stays for free and logged-out
     visitors, where it earns its place. */
  function ldcHideLead() {
    try {
      var C = window.LAYERD && window.LAYERD.components;
      return !!(C && C.isMember && C.isMember());
    } catch (e) { return false; }
  }
  function fileCakeSaved() {
    try {
      var F = window.LdCakeFile;
      if (!F || !F.readCake) return true;          /* no file layer: scratch flow */
      var rc = F.readCake();
      if (!rc || !rc.booking) return true;         /* unscoped: genuinely saved */
      return !!(rc.booking.cake && rc.booking.cake.updatedAt > 0);
    } catch (e) { return true; }
  }
  function comboLabel(combo) {
    return combo.sizes.slice().sort(function (a, b) { return a - b; })
      .map(function (s) { return sizeLabel(s); }).join(' + ');
  }
  document.getElementById('ldcGuestsResults').addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.ldc-combo-use') : null;
    if (!btn || !lastGuestCombos) return;
    var idx = parseInt(btn.getAttribute('data-use-combo'), 10);
    var combo = lastGuestCombos[idx];
    if (!combo) return;
    chosenComboIdx = idx;
    guestPicked = true;   /* r99: from here the headline card is HER cake */
    var tiers = combo.sizes.map(function (s) { return { shape: searchShape(), size: s, height: combo.height || state.guestHeight }; });
    /* Toolkit Fix 01 semantics unchanged: scoped picks go through the
       explicit "Update [name]'s file" flow; unscoped picks write the
       scratch slot (inside renderGuestResults). The redesign re-renders
       the whole result so the picked cake takes the detailed drawing. */
    var scoped = servingBooking && window.LdCakeFile;
    renderGuestResults();
    if (scoped) {
      var results = document.getElementById('ldcGuestsResults');
      /* r17: anchor the question to the card she just tapped. This used to
         look for '.ldc-cc.is-chosen', which no longer matches before a save
         (the tick is honest now) - so the prompt fell to the very bottom of
         the page, measured at y=2307, and tapping "Use this cake" looked
         like it did nothing at all. The card she tapped is the right home
         for it whether or not anything is saved yet. */
      var host = results.querySelector('.ldc-cc[data-combo="' + idx + '"]')
        || results.querySelector('.ldc-cc.is-chosen') || results;
      wireScopedSave(host, tiers);
    }
  });

  /* 2026-09-14: always-live (brief) - the recommended cake appears as the
     guest count is typed, no "Calculate My Cake" button. `live` keeps quiet
     while she is mid-entry (empty or a not-yet-valid number just clears the
     result, no scolding error); the >1,000 guard still speaks. The same
     function still backs any explicit trigger. */
  function computeGuests(live) {
    var input = document.getElementById('ldcGuestCount');
    var errorEl = document.getElementById('ldcGuestError');
    var resultsEl = document.getElementById('ldcGuestsResults');
    var raw = input.value.trim();
    var guests = parseInt(raw, 10);

    errorEl.hidden = true;

    if (!raw || isNaN(guests) || guests <= 0) {
      resultsEl.hidden = true;
      lastGuestCtx = null;
      if (!live) { errorEl.textContent = 'Please enter a guest count greater than 0.'; errorEl.hidden = false; }
      return;
    }
    if (guests > 1000) {
      resultsEl.hidden = true;
      lastGuestCtx = null;
      errorEl.textContent = 'For events over 1,000 guests, please reach out directly for a custom plan - tiered cakes alone are usually not practical at that scale.';
      errorEl.hidden = false;
      return;
    }

    var useOtherDesserts = document.getElementById('ldcOtherDesserts').checked;
    var target = useOtherDesserts ? Math.ceil(guests * OTHER_DESSERTS_FACTOR) : guests;
    var rec = recommendCombos(target, state.occasion, state.guestTiers);
    lastGuestCtx = { rec: rec, target: target, guests: guests, useOther: useOtherDesserts };
    renderGuestResults();
    leadCard.hidden = ldcHideLead();
    /* r46: the Print row is NOT the lead card — results on screen means
       printable, member or not. (S-4 hid the card the button used to
       live in, which silently cost members the print option.) */
    var pr = document.getElementById('ldcPrintRow');
    if (pr) pr.hidden = false;
  }
  /* debounced live recompute for the guest count field; occasion / tier /
     other-desserts changes recompute at once (a discrete choice, not typing) */
  var _guestLiveTimer = null;
  function liveGuests() { clearTimeout(_guestLiveTimer); _guestLiveTimer = setTimeout(function () { computeGuests(true); }, 200); }
  (function () {
    var gi = document.getElementById('ldcGuestCount');
    if (gi) gi.addEventListener('input', liveGuests);
    var od = document.getElementById('ldcOtherDesserts');
    if (od) od.addEventListener('change', function () { computeGuests(true); });
    var cb = document.getElementById('ldcCalcGuestsBtn');   /* button retired by always-live */
    if (cb) cb.style.display = 'none';   /* .hidden loses to the button's display rule */
  })();

  /* the guest render is a pure function of (ctx, chosenComboIdx) so picking
     a different stack re-renders the whole result — the picked cake takes
     the ONE detailed drawing, the rest stay quiet minis (redesign rule). */
  var lastGuestCtx = null;
  /* P3-4: changing the pan wall changes which stacks WIN, not just how they
     draw — so it has to re-run the search, not just repaint the cards. */
  function regenerateGuests() {
    if (!lastGuestCtx) return;
    lastGuestCtx.rec = recommendCombos(lastGuestCtx.target, state.occasion, state.guestTiers);
    chosenComboIdx = 0;
    renderGuestResults();
  }
  function renderGuestResults() {
    if (!lastGuestCtx) return;
    var rec = lastGuestCtx.rec, target = lastGuestCtx.target,
        guests = lastGuestCtx.guests, useOtherDesserts = lastGuestCtx.useOther;
    var resultsEl = document.getElementById('ldcGuestsResults');

    var html = '';
    html += '<div class="ld-result ld-result--outcome"><div class="ld-result__head">';
    /* r99: the Wilton basis rides beside the number it qualifies */
    html += '<span class="ld-result__label">Target servings' +
      infoBtnHtml(WILTON_NOTE, 'How these servings are counted') + '</span>';
    html += '<span class="ld-result__answer">' + target + '</span>';
    html += '</div>';
    if (useOtherDesserts) {
      html += '<p class="ldc-result-note">Planning for ' + Math.round(OTHER_DESSERTS_FACTOR * 100) + '% of your ' + guests + ' guests (the commonly used 75-85% range when other desserts are served).</p>';
    }
    html += '</div>';

    if (rec.shortfall) {
      html += '<p class="ldc-result-note is-warning">Even our largest classic round stack tops out below ' + target + ' servings. Consider adding a sheet cake to supplement, or splitting into two cakes - reach out and we can help you plan it.</p>';
    }
    if (rec.prefMiss) {
      html += '<p class="ldc-result-note">No ' + state.guestTiers + '-tier stack lands neatly on this count - here are the closest looks instead.</p>';
    }

    /* the baker picks their default (Mariya, 2026-07-13): every combo is
       selectable; the recommended one starts selected and saved, and
       tapping another makes THAT the cake every Learn tool reads. The
       choice survives unit-flip re-renders (same handler re-runs). */
    lastGuestCombos = rec.combos;
    if (chosenComboIdx >= rec.combos.length) chosenComboIdx = 0;
    if (rec.combos.length > 0) {
      var cc0 = rec.combos[chosenComboIdx];
      var ccH = cc0.height || state.guestHeight;
      var ccTiers = cc0.sizes.map(function (s) { return { shape: searchShape(), size: s, height: ccH }; });
      /* P3-4: the headline stack states its own honesty before the drawing */
      if (cc0.surplus < 0) {
        html += '<p class="ldc-result-note ldc-result-note--short">This stack serves about ' + cc0.total +
          ' of ' + target + ', ' + (-cc0.surplus) + ' short.' +
          (cc0.offPan === 0 ? ' It keeps to standard pan sizes;' : '') +
          ' size up one tier if every guest must have a slice.</p>';
      }
      /* r99 (Mariya): until she picks one, this stack is the studio's
         RECOMMENDATION — it becomes "your cake" the moment she chooses it
         (and, on a client file, once that choice is actually saved) */
      html += cakeCardHtml(ccTiers, (guestPicked && fileCakeSaved()) ? 'Your cake' : 'Recommended cake');
      publishPlan(ccTiers, cc0.total, target, guests);   /* r191: the sheet */
      html += dbarrelHtml(ccH);
      html += legendHtml(ccTiers, state.occasion);
      if (rec.combos.length > 1) {
        html += '<div class="ldc-alts"><div class="ldc-alts__h">Other ways to serve ~' + target + '</div>' +
          (fileCakeSaved()
            ? '<div class="ldc-alts__sub">Same guest count &middot; different stacks and tier heights. Tap one to make it your cake.</div>'
            : '<div class="ldc-alts__sub ldc-alts__sub--pick">Pick the one you want and it saves to this client\u2019s file. Nothing is chosen yet.</div>') +
          '<div class="ldc-compare">';
      } else {
        html += '<div class="ldc-alts"><div class="ldc-compare">';
      }
      rec.combos.forEach(function (combo, idx) {
        var comboH = combo.height || state.guestHeight;
        var tiers = combo.sizes.map(function (s) { return { shape: searchShape(), size: s, height: comboH }; });
        var chosen = idx === chosenComboIdx && fileCakeSaved();
        var tag = idx === 0
          ? '<span class="ldc-cc__tag ldc-cc__tag--match">Closest match</span>'
          : '<span class="ldc-cc__tag">' + (combo.sizes.length < rec.combos[0].sizes.length ? 'Fewer tiers'
              : combo.sizes.length > rec.combos[0].sizes.length ? 'More tiers'
              : comboH > (rec.combos[0].height || state.guestHeight) ? 'Taller tiers'
              : comboH < (rec.combos[0].height || state.guestHeight) ? 'Shorter tiers' : 'Alternative') + '</span>';
        html += '<div class="ldc-combo-card ldc-cc' + (chosen ? ' is-chosen' : '') + '" data-combo="' + idx + '">' + tag +
          renderStack(tiers, { mini: true }) +
          '<div class="ldc-cc__sizes">' + combo.sizes.slice().sort(function (a, b) { return a - b; }).map(function (n) { return sizeLabel(n); }).join(' ') + '</div>' +
          '<div class="ldc-cc__meta">' + combo.total + ' servings · ' + sizeLabel(comboH) + ' tall' +
            (combo.surplus > 0 ? ' · ' + combo.surplus + ' spare' : '') +
            /* P3-4: a stack that lands just under the count says so, in the
               same breath as the count — never rounded up in silence */
            (combo.surplus < 0 ? ' · <b class="ldc-cc__short">' + (-combo.surplus) + ' short of ' + target + '</b>' : '') + '</div>' +
          dbarrelHtml(comboH) +
          '<button type="button" class="ldc-combo-use" data-use-combo="' + idx + '" aria-pressed="' + (chosen ? 'true' : 'false') + '">' +
          (chosen ? '✓ Saved as your cake' : 'Select this cake') + '</button></div>';
      });
      html += '</div>';
      /* r51 (Mariya, 2026-08-18): "too wordy and repetitive". The line
         "Only the cake you pick gets the full drawing — the others stay
         quiet on purpose" was the UI narrating its own design decision —
         nobody was asking. Deleted, not shortened. */
      html += '</div>';
    }

    if (rec.combos.length > 0) {
      /* scoped: nothing is saved until a stack is PICKED — say so up front,
         right above the cards, so nobody stalls wondering what happens next
         (Mariya, 2026-07-16). */
      if (servingBooking && window.LdCakeFile) {
        html = '<div class="ld-callout ld-callout--check ldc-pickhint">' +
          '<span class="ld-callout__label">Almost there</span>' +
          'Tap “Select this cake” on a stack below to save it to ' +
          ((servingBooking.name || '').trim() || 'the client') + '’s file, then the bar up top points to the next step.</div>' + html;
      }
      var chosenTiers = rec.combos[chosenComboIdx].sizes.map(function (s) {
        return { shape: searchShape(), size: s, height: rec.combos[chosenComboIdx].height || state.guestHeight };
      });
      if (saveSharedCake(chosenTiers)) {
        html += fileCakeSaved()
          ? sharedNote(chosenComboIdx === 0 ? 'Recommended stack saved as your cake'
              : comboLabel(rec.combos[chosenComboIdx]) + ' saved as your cake')
          : sharedNote('Nothing saved to this file yet. Choose a cake below', true);
      }
      if (!servingBooking) html += startFileHtml();
    }


    resultsEl.innerHTML = html;
    if (!servingBooking) {
      wireStartFile(resultsEl, function () {
        if (!lastGuestCombos || !lastGuestCombos[chosenComboIdx]) return null;
        return lastGuestCombos[chosenComboIdx].sizes.map(function (s) {
          return { shape: searchShape(), size: s, height: lastGuestCombos[chosenComboIdx].height || state.guestHeight };
        });
      });
    }
    resultsEl.hidden = false;
  }

  /* ======================= MODE 2: KNOWN TIERS -> TOTAL SERVINGS ======================= */

  var tierRowsEl = document.getElementById('ldcTierRows');
  var tierRowCount = 0;

  function sizeOptionsFor(shape) {
    return Object.keys(SERVINGS[shape]).map(Number).sort(function (a, b) { return a - b; });
  }

  function addTierRow() {
    tierRowCount++;
    var rowId = 'ldcTierRow' + tierRowCount;
    var row = document.createElement('div');
    row.className = 'ldc-tier-row';
    row.id = rowId;

    var shapeSelect = document.createElement('select');
    shapeSelect.className = 'ldc-tier-shape';
    ['round', 'square', 'heart'].forEach(function (shape) {
      var opt = document.createElement('option');
      opt.value = shape;
      opt.textContent = SHAPE_LABEL[shape];
      shapeSelect.appendChild(opt);
    });

    var sizeSelect = document.createElement('select');
    sizeSelect.className = 'ldc-tier-size';

    function populateSizes() {
      var shape = shapeSelect.value;
      sizeSelect.innerHTML = '';
      sizeOptionsFor(shape).forEach(function (size) {
        var opt = document.createElement('option');
        opt.value = size;
        opt.textContent = sizeLabel(size);
        sizeSelect.appendChild(opt);
      });
    }
    populateSizes();
    shapeSelect.addEventListener('change', populateSizes);

    var heightSelect = document.createElement('select');
    heightSelect.className = 'ldc-tier-height';
    /* r221 (Mariya): a 3" tier - two layers - as a choice. Servings scale
       with height on the Wilton chart (h / 4), so it is 3/4 of the 4"
       count; 4" stays the default for a new row. */
    [3, 4, 5, 6, 7, 8].forEach(function (h) {
      var opt = document.createElement('option');
      opt.value = h;
      opt.textContent = sizeLabel(h) + ' tall';
      heightSelect.appendChild(opt);
    });
    heightSelect.value = '4';

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'ldc-tier-remove';
    removeBtn.innerHTML = '×';
    removeBtn.setAttribute('aria-label', 'Remove tier');
    removeBtn.addEventListener('click', function () {
      row.remove();
      renumberTierRows();
    });

    var num = document.createElement('span');
    num.className = 'ldc-tier-num';
    num.setAttribute('aria-hidden', 'true');

    row.appendChild(num);
    row.appendChild(shapeSelect);
    row.appendChild(sizeSelect);
    row.appendChild(heightSelect);
    row.appendChild(removeBtn);
    tierRowsEl.appendChild(row);
    renumberTierRows();
  }

  function renumberTierRows() {
    var rows = tierRowsEl.querySelectorAll('.ldc-tier-row');
    Array.prototype.forEach.call(rows, function (r, i) {
      var n = r.querySelector('.ldc-tier-num');
      if (n) n.textContent = i + 1;
    });
  }

  document.getElementById('ldcAddTierBtn').addEventListener('click', addTierRow);
  addTierRow(); // start with one row

  // Re-label rows in place on a unit flip; option VALUES stay inches.
  function relabelTierRows() {
    tierRowsEl.querySelectorAll('.ldc-tier-row').forEach(function (row) {
      var ss = row.querySelector('.ldc-tier-size');
      var hs = row.querySelector('.ldc-tier-height');
      Array.prototype.forEach.call(ss.options, function (o) { o.textContent = sizeLabel(parseInt(o.value, 10)); });
      Array.prototype.forEach.call(hs.options, function (o) { o.textContent = sizeLabel(parseInt(o.value, 10)) + ' tall'; });
    });
  }

  /* 2026-09-14: always-live (brief) - servings update as tiers are added,
     removed or resized; no "Calculate servings" button. */
  function computeTiers(live) {
    var errorEl = document.getElementById('ldcTierError');
    var resultsEl = document.getElementById('ldcTiersResults');
    errorEl.hidden = true;

    var rows = tierRowsEl.querySelectorAll('.ldc-tier-row');
    if (rows.length === 0) {
      resultsEl.hidden = true;
      if (!live) { errorEl.textContent = 'Add at least one tier to calculate servings.'; errorEl.hidden = false; }
      return;
    }

    var tiers = [];
    rows.forEach(function (row) {
      var shape = row.querySelector('.ldc-tier-shape').value;
      var size = parseInt(row.querySelector('.ldc-tier-size').value, 10);
      var height = parseInt(row.querySelector('.ldc-tier-height').value, 10) || 4;
      tiers.push({ shape: shape, size: size, height: height,
                   faux: row.getAttribute('data-faux') === '1' });
    });

    /* r42: faux tiers feed nobody, so they never count toward servings */
    var total = tiers.reduce(function (sum, t) {
      return t.faux ? sum : sum + servingsFor(t.shape, t.size, state.occasion, t.height);
    }, 0);
    var fauxN = tiers.filter(function (t) { return t.faux; }).length;

    var html = '';
    html += '<div class="ldc-heroresult">' +
      '<div><div class="ldc-heroresult__eyebrow">This will serve up to' +
        infoBtnHtml(WILTON_NOTE, 'How these servings are counted') + '</div>' +
      '<div class="ldc-heroresult__meta">' + tiers.length + (tiers.length === 1 ? ' tier' : ' tiers') +
        (fauxN ? ' · ' + fauxN + ' faux (serves nobody)' : '') +
        ' · ' + state.occasion + ' slices</div></div>' +
      '<div class="ldc-heroresult__n">' + total + '</div></div>';
    html += cakeCardHtml(tiers);
    publishPlan(tiers, total, null, null);   /* r191: no target in tiers mode */
    html += legendHtml(tiers, state.occasion);

    /* Toolkit Fix 01 §3.3: while a client file is active the persist is an
       EXPLICIT choice (update the file vs this calculation only) — never a
       silent write. Unscoped keeps today's scratch-slot behaviour. */
    if (!servingBooking || !window.LdCakeFile) {
      if (saveSharedCake(tiers)) html += sharedNote('Saved as your cake');
      if (!servingBooking) html += startFileHtml();
    }


    resultsEl.innerHTML = html;
    if (servingBooking && window.LdCakeFile) wireScopedSave(resultsEl, tiers);
    else if (servingBooking) wireSaveStack(resultsEl, tiers);   /* no-helper fallback */
    else wireStartFile(resultsEl, function () { return tiers; });
    resultsEl.hidden = false;
    leadCard.hidden = ldcHideLead();
    /* r46: the Print row is NOT the lead card — results on screen means
       printable, member or not. (S-4 hid the card the button used to
       live in, which silently cost members the print option.) */
    var pr = document.getElementById('ldcPrintRow');
    if (pr) pr.hidden = false;
  }
  /* wire always-live for the tiers mode: any tier add/remove/resize recomputes;
     occasion is handled in the shared occasion hook. */
  (function () {
    if (tierRowsEl) {
      tierRowsEl.addEventListener('change', function () { computeTiers(true); });
      tierRowsEl.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.ldc-tier-remove')) setTimeout(function () { computeTiers(true); }, 0);
      });
    }
    var addb = document.getElementById('ldcAddTierBtn');
    if (addb) addb.addEventListener('click', function () { setTimeout(function () { computeTiers(true); }, 0); });
    var tb = document.getElementById('ldcCalcTiersBtn');
    if (tb) tb.style.display = 'none';   /* button retired by always-live */
  })();

  /* ======================= MODE 3: CLIENT'S BUDGET -> STACKS (Budget build, 2026-08-21) =======================
     Reverse sizing on the FREE tier (her call, 2026-08-21: free to try;
     exactness is the Pro line). The search runs the guest-mode candidate
     space against the SAME two rounded per-serving endpoints the free
     Pricing page publishes (#ldc-ballpark, one build-time source) - so
     every answer is a RANGE, never an exact number, and no rate ships
     here. The exact version (the member's own rates, market, extras)
     lives on the Pricing page. */
  var BALLPARK = null;
  try {
    var bpEl = document.getElementById('ldc-ballpark');
    BALLPARK = bpEl ? JSON.parse(bpEl.textContent) : null;
    if (BALLPARK && !BALLPARK.bands) BALLPARK = null;
  } catch (eBp) { BALLPARK = null; }
  var budgetPanel = document.getElementById('ldcBudgetPanel');
  var budgetResults = document.getElementById('ldcBudgetResults');
  var lastBudgetCtx = null, chosenBudgetIdx = 0;

  /* same rounding the free Pricing range uses - a budget answer and a
     ballpark quote for the same stack must read as the same numbers */
  function budgetRound5(n) { return Math.max(5, Math.round(n / 5) * 5); }
  function budgetPriceRange(sv) {
    var bd = BALLPARK.bands[state.budgetBand] || BALLPARK.bands.simple;
    var lo = budgetRound5(bd.lo * sv), hi = budgetRound5(bd.hi * sv);
    /* the order minimum, same clamp as the free quote - fixed costs don't
       shrink with the cake */
    var om = +BALLPARK.orderMin || 0;
    if (om > 0 && lo < om) { lo = om; if (hi < om) hi = om; }
    return { lo: lo, hi: hi };
  }
  /* r197: budget mode runs on the SAME two ballpark endpoints the free
     Pricing page publishes, and those are researched in US dollars. Pricing
     can now quote in any currency, so this follows the shared preference
     rather than hard-coding a dollar sign - a member quoting in euros must
     not read one page in EUR and the other in USD for the same number.
     Symbol only, exactly as on Pricing: nothing is converted. */
  function budgetCurrency() {
    var c = '';
    try { c = (localStorage.getItem('layerd-learn-currency') || '').toUpperCase(); } catch (e) { }
    if (c === 'US') return 'USD';        /* pre-r197 country values */
    if (c === 'CA') return 'CAD';
    return /^[A-Z]{3}$/.test(c) ? c : 'USD';
  }
  /* the same formatter with the currency's own decimals, for the per-serving
     rate line (budgetMoney rounds to whole units for totals) */
  var _brFmt = null, _brFor = '';
  function budgetRate(n) {
    var code = budgetCurrency();
    if (!_brFmt || _brFor !== code) {
      _brFor = code;
      try { _brFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: code }); }
      catch (e) { _brFmt = null; }
    }
    return _brFmt ? _brFmt.format(n) : (code + ' ' + n.toFixed(2));
  }
  var _bmFmt = null, _bmFor = '';
  function budgetMoney(n) {
    var code = budgetCurrency();
    if (!_bmFmt || _bmFor !== code) {
      _bmFor = code;
      try {
        _bmFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: code,
          minimumFractionDigits: 0, maximumFractionDigits: 0 });
      } catch (e) { _bmFmt = null; }
    }
    var v = Math.round(n);
    return _bmFmt ? _bmFmt.format(v) : (code + ' ' + v.toLocaleString('en-US'));
  }

  /* MEMBER EXACT (2026-09-11, Mariya): the budget answer was a research RANGE
     for everyone, so a member who had already set her own per-serving rate on
     Pricing still got the range and the "Pro prices with your rates" teaser -
     reading, rightly, as "treated like free". Her rate is saved per cover band
     by the Pricing page (layerd-pricing-band-rates: {bands:{simple,fondant,..}},
     the per-serving figure she charges). Same origin, so we read it here without
     loading the gated pricing engine. When it exists we collapse this band to
     that single rate (lo === hi) and the whole search returns EXACT servings and
     prices with no core change. Members only; free users keep the range and
     never have the key. Extras/delivery still belong to the Pricing quote. */
  var BUDGET_RATE_KEY = 'layerd-pricing-band-rates';
  function memberBandRate() {
    if (svGaTier() !== 'premium') return null;
    try {
      var raw = localStorage.getItem(BUDGET_RATE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw), bands = (p && p.bands) || {};
      var r = bands[state.budgetBand];
      return (typeof r === 'number' && r > 0) ? r : null;
    } catch (e) { return null; }
  }
  /* the ballpark to price with: the researched island, or - for a member with a
     saved rate for this band - a clone whose band is that single exact rate */
  function budgetBallpark() {
    if (!BALLPARK) return BALLPARK;
    var rate = memberBandRate();
    if (rate == null) return BALLPARK;
    var clone = { orderMin: BALLPARK.orderMin, labels: BALLPARK.labels, bands: {} };
    for (var k in BALLPARK.bands) { if (BALLPARK.bands.hasOwnProperty(k)) clone.bands[k] = BALLPARK.bands[k]; }
    clone.bands[state.budgetBand] = { lo: rate, hi: rate };
    return clone;
  }
  function effBand() {
    var bp = budgetBallpark();
    return (bp && bp.bands && (bp.bands[state.budgetBand] || bp.bands.simple)) || null;
  }
  /* a stack's money: a range normally, one figure when the endpoints are equal
     (a member rate collapses lo === hi, and "CA$785 – CA$785" reads as a bug) */
  function budgetMoneyRange(lo, hi) {
    return (lo === hi) ? budgetMoney(lo) : (budgetMoney(lo) + '–' + budgetMoney(hi));
  }

  /* SPINE 2026-09-06: the budget search moved VERBATIM into cake-core
     (CORE.recommendBudget) so the Studio and this page run ONE engine. Thin
     delegate now — the ballpark island and cover band stay page-owned and are
     passed through, so the output is byte-identical to the pre-lift function.
     2026-09-11: a member's own band rate (budgetBallpark) rides the same path,
     so exact pricing needs no change to the shared engine. */
  function recommendBudget(budget, occasion, prefTiers) {
    return CORE.recommendBudget(budget, occasion, {
      prefTiers: prefTiers,
      heights: GUEST_HEIGHTS.map(function (g) { return g[0]; }),
      ballpark: budgetBallpark(),
      band: state.budgetBand,
      shape: budgetShape()
    });
  }

  /* always-live compute for the budget mode. Declared here at IIFE scope (the
     real body is assigned inside the `budgetPanel && BALLPARK` block below, so
     restore/recompute call sites out here can reach it in strict mode); a no-op
     until then, which is correct when the budget island never loaded. */
  var computeBudget = function () {};

  /* pure function of (ctx, chosenBudgetIdx), same rule as the guest render */
  function regenerateBudget() {
    if (!lastBudgetCtx) return;
    lastBudgetCtx.rec = recommendBudget(lastBudgetCtx.budget, state.occasion, state.budgetTiers);
    chosenBudgetIdx = 0;
    renderBudgetResults();
  }
  function renderBudgetResults() {
    if (!lastBudgetCtx || !BALLPARK) return;
    var rec = lastBudgetCtx.rec, budget = lastBudgetCtx.budget;
    var bd = effBand();
    var exact = memberBandRate() != null;          /* member priced with her own rate */
    var svLo = Math.floor(budget / bd.hi), svHi = Math.floor(budget / bd.lo);
    var svText = (svLo === svHi) ? ('' + svLo) : (svLo + '\u2013' + svHi);
    var rateText = (bd.lo === bd.hi) ? budgetRate(bd.lo) : (budgetRate(bd.lo) + '\u2013' + budgetRate(bd.hi));
    var bandLabel = ((BALLPARK.labels && BALLPARK.labels[state.budgetBand]) || state.budgetBand).toLowerCase();
    var html = '';
    html += '<div class="ldc-heroresult">' +
      '<div><div class="ldc-heroresult__eyebrow">This budget buys about</div>' +
      /* r197: the per-serving endpoints follow the currency preference too,
         and say plainly that they are researched in USD when it is not -
         the same caveat the free Pricing page carries, for the same number.
         2026-09-11: with a member rate the two endpoints are equal, so the line
         reads as one exact number and names it as HER rate, not the average. */
      '<div class="ldc-heroresult__meta">' + state.occasion + ' servings \u00b7 at ' +
        rateText + ' each, ' +
        (exact ? 'your ' + bandLabel + ' rate'
               : 'the studio average' + (budgetCurrency() === 'USD' ? '' : ' (researched in US dollars)')) +
      '</div></div>' +
      '<div class="ldc-heroresult__n' + (svLo === svHi ? '' : ' ldc-heroresult__n--range') + '">' + svText + '</div></div>';
    /* three voices (2026-09-11): a member priced with her own rate gets a plain
       confirmation (no upsell); a member who has not set a rate yet gets a quiet
       pointer to do so; free/visitor keeps her 2026-08-21 Pro line, first, so a
       range reads as a teaser and not a limitation. */
    if (exact) {
      html += '<p class="ldc-shared-note ldc-budget-pro">Priced at your saved ' + bandLabel + ' rate from Pricing. Extras and delivery still live on the <a href="' + svPricingUrl() + '">Pricing</a> quote.</p>';
    } else if (svGaTier() === 'premium') {
      html += '<p class="ldc-shared-note ldc-budget-pro">These are studio averages. Set your per-serving rate on <a href="' + svPricingUrl() + '">Pricing</a> and this prices with your own numbers instead.</p>';
    } else {
      html += '<p class="ldc-shared-note ldc-budget-pro">These are studio averages \u00b7 <a href="' + svPricingUrl() + '">LAYER\u2019D Toolkit Pro prices any of these exactly</a>, with your own rates and extras.</p>';
    }
    if (rec.shortfall) {
      var c0s = rec.combos[0];
      html += '<p class="ldc-result-note is-warning">The smallest custom cake starts around ' +
        (c0s.lo === c0s.hi ? budgetMoney(c0s.lo) : budgetMoney(c0s.lo) + '\u2013' + budgetMoney(c0s.hi)) +
        ' \u00b7 ' + budgetMoney(c0s.lo - budget) + ' over this budget.</p>';
    }
    if (rec.prefMiss) {
      html += '<p class="ldc-result-note">No ' + state.budgetTiers + '-tier stack lands inside this budget - here are the closest looks instead.</p>';
    }
    if (chosenBudgetIdx >= rec.combos.length) chosenBudgetIdx = 0;
    if (rec.combos.length > 0) {
      var cc0 = rec.combos[chosenBudgetIdx];
      var ccH = cc0.height || 4;
      var ccTiers = cc0.sizes.map(function (s) { return { shape: searchShape(), size: s, height: ccH }; });
      /* the chosen stack states its own money in the same breath (P3-4
         copy discipline): a range, and over when it could run over */
      html += '<p class="ldc-result-note' + (cc0.hi > budget && !rec.shortfall ? ' ldc-result-note--short' : '') + '">' +
        cc0.total + ' servings \u00b7 ' + (cc0.lo === cc0.hi ? '' : '\u2248 ') + budgetMoneyRange(cc0.lo, cc0.hi) +
        (cc0.hi <= budget ? ' \u00b7 fits the ' + budgetMoney(budget) + ' budget'
          : rec.shortfall ? ''
          : ' \u00b7 ' + budgetMoney(cc0.hi - budget) + ' over' + (cc0.lo === cc0.hi ? ' budget' : ' at the top of the range')) + '</p>';
      html += cakeCardHtml(ccTiers, (budgetPicked && fileCakeSaved()) ? 'Your cake' : 'Recommended cake');
      /* r191: budget mode sizes to MONEY, so there is no guest target to
         hold the count against — the sheet drops that line rather than
         inventing one. */
      publishPlan(ccTiers, cc0.total, null, null);
      html += dbarrelHtml(ccH);
      html += legendHtml(ccTiers, state.occasion);
      if (rec.combos.length > 1) {
        html += '<div class="ldc-alts"><div class="ldc-alts__h">Other ways to spend ' + budgetMoney(budget) + '</div>' +
          (fileCakeSaved()
            ? '<div class="ldc-alts__sub">Same budget \u00b7 different stacks. Tap one to make it your cake.</div>'
            : '<div class="ldc-alts__sub ldc-alts__sub--pick">Pick the one you want and it saves to this client\u2019s file. Nothing is chosen yet.</div>') +
          '<div class="ldc-compare">';
      } else {
        html += '<div class="ldc-alts"><div class="ldc-compare">';
      }
      rec.combos.forEach(function (combo, idx) {
        var comboH = combo.height || 4;
        var tiers = combo.sizes.map(function (s) { return { shape: searchShape(), size: s, height: comboH }; });
        var chosen = idx === chosenBudgetIdx && fileCakeSaved();
        var isStretch = !rec.shortfall && idx >= rec.stretchFrom;
        var tag = rec.shortfall
          ? '<span class="ldc-cc__tag">Closest to budget</span>'
          : idx === 0 ? '<span class="ldc-cc__tag ldc-cc__tag--match">Best fit</span>'
          : isStretch ? '<span class="ldc-cc__tag">A stretch</span>'
          : '<span class="ldc-cc__tag">' + (combo.sizes.length < rec.combos[0].sizes.length ? 'Fewer tiers'
              : combo.sizes.length > rec.combos[0].sizes.length ? 'More tiers'
              : comboH > (rec.combos[0].height || 4) ? 'Taller tiers'
              : comboH < (rec.combos[0].height || 4) ? 'Shorter tiers' : 'Alternative') + '</span>';
        html += '<div class="ldc-combo-card ldc-cc' + (chosen ? ' is-chosen' : '') + '" data-combo="' + idx + '">' + tag +
          renderStack(tiers, { mini: true }) +
          '<div class="ldc-cc__sizes">' + combo.sizes.slice().sort(function (a, b) { return a - b; }).map(function (n) { return sizeLabel(n); }).join(' ') + '</div>' +
          '<div class="ldc-cc__meta">' + combo.total + ' servings \u00b7 ' + sizeLabel(comboH) + ' tall' +
            '<br>' + (combo.lo === combo.hi ? '' : '\u2248 ') + budgetMoneyRange(combo.lo, combo.hi) +
            (combo.hi > budget ? ' \u00b7 <b class="ldc-cc__short">' + (combo.lo === combo.hi ? '' : 'up to ') + budgetMoney(combo.hi - budget) + ' over</b>' : '') + '</div>' +
          dbarrelHtml(comboH) +
          '<button type="button" class="ldc-combo-use" data-use-combo="' + idx + '" aria-pressed="' + (chosen ? 'true' : 'false') + '">' +
          (chosen ? '\u2713 Saved as your cake' : 'Select this cake') + '</button></div>';
      });
      html += '</div></div>';
    }
    if (rec.combos.length > 0) {
      /* scoped: nothing saves until a stack is PICKED - say so up front,
         exactly like guest mode */
      if (servingBooking && window.LdCakeFile) {
        html = '<div class="ld-callout ld-callout--check ldc-pickhint">' +
          '<span class="ld-callout__label">Almost there</span>' +
          'Tap \u201cSelect this cake\u201d on a stack below to save it to ' +
          ((servingBooking.name || '').trim() || 'the client') + '\u2019s file. Then the bar up top points to the next step.</div>' + html;
      }
      var chosenTiers2 = rec.combos[chosenBudgetIdx].sizes.map(function (s) {
        return { shape: searchShape(), size: s, height: rec.combos[chosenBudgetIdx].height || 4 };
      });
      if (saveSharedCake(chosenTiers2)) {
        html += fileCakeSaved()
          ? sharedNote(chosenBudgetIdx === 0 ? 'Best-fit stack saved as your cake'
              : comboLabel(rec.combos[chosenBudgetIdx]) + ' saved as your cake')
          : sharedNote('Nothing saved to this file yet. Choose a cake below', true);
      }
      if (!servingBooking) html += startFileHtml();
    }
    /* r224 (Mariya: remove pipeline redirects outside the client chip). The
       members' "Price it exactly in Pricing" door was a second next-step voice
       competing with the chip; the chip owns where the pipeline goes next. The
       free-tier "Pro prices these exactly" line above stays - that is a Pro
       upsell, not a pipeline step. */
    budgetResults.innerHTML = html;
    if (!servingBooking) {
      wireStartFile(budgetResults, function () {
        var c = lastBudgetCtx && lastBudgetCtx.rec.combos[chosenBudgetIdx];
        if (!c) return null;
        return c.sizes.map(function (s) { return { shape: searchShape(), size: s, height: c.height || 4 }; });
      });
    }
    budgetResults.hidden = false;
  }

  /* wiring - only when the panel AND its island are real; a stale template
     or missing island says so instead of half-rendering */
  if (budgetPanel && !BALLPARK) {
    (function () {
      var go = document.getElementById('ldcCalcBudgetBtn');
      var er = document.getElementById('ldcBudgetError');
      if (go && er) {
        go.addEventListener('click', function () {
          er.textContent = 'This mode couldn\u2019t load its settings. Please refresh the page.';
          er.hidden = false;
        });
      }
    })();
  }
  function paintBudgetBands() {
    var box = document.getElementById('ldcBudgetBand');
    var hint = document.getElementById('ldcBudgetBandHint');
    if (!box || !BALLPARK) return;
    var keys = ['simple', 'fondant'].filter(function (k) { return BALLPARK.bands[k]; });
    if (!keys.length) keys = Object.keys(BALLPARK.bands);
    if (BALLPARK.bands[state.budgetBand] === undefined) state.budgetBand = keys[0];
    box.innerHTML = '';
    keys.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ld-chip' + (state.budgetBand === k ? ' is-active' : '');
      b.setAttribute('aria-pressed', state.budgetBand === k ? 'true' : 'false');
      b.textContent = (BALLPARK.labels && BALLPARK.labels[k]) || k;
      b.addEventListener('click', function () {
        state.budgetBand = k;
        paintBudgetBands();
        if (budgetResults && !budgetResults.hidden) regenerateBudget();
      });
      box.appendChild(b);
    });
    /* 2026-09-11: this hint was ungated and hard-coded a $, so it promised
       every member "Toolkit Pro prices with your own rates instead" while the
       tool never did - the contradiction Mariya flagged. Now it follows the
       same three voices as the result, and uses the currency formatter. */
    var bd = BALLPARK.bands[state.budgetBand];
    if (hint && bd) {
      var mr = memberBandRate();
      if (mr != null) {
        hint.textContent = 'Priced at your saved rate of ' + budgetRate(mr) + ' per serving.';
      } else if (svGaTier() === 'premium') {
        hint.textContent = 'Studio average ' + budgetRate(bd.lo) + '\u2013' + budgetRate(bd.hi) + ' per serving. Set your rate on Pricing to price with your own numbers.';
      } else {
        hint.textContent = 'Typically ' + budgetRate(bd.lo) + '\u2013' + budgetRate(bd.hi) + ' per serving \u00b7 Toolkit Pro prices with your own rates instead.';
      }
    }
  }
  if (budgetPanel && BALLPARK) {
    paintBudgetBands();
    CORE.wirePanWall({
      box: document.getElementById('ldcBudgetPans'),
      now: document.getElementById('ldcBudgetPansNow'),
      reset: document.getElementById('ldcBudgetPansReset'),
      onChange: function () { regenerateBudget(); }
    });
    var budgetTiersSel = document.getElementById('ldcBudgetTiers');
    if (budgetTiersSel) {
      budgetTiersSel.addEventListener('change', function () {
        state.budgetTiers = parseInt(budgetTiersSel.value, 10) || 0;
        if (budgetResults && !budgetResults.hidden) regenerateBudget();
      });
    }
    /* r223: shape change re-runs the budget search */
    var budgetShapeSel = document.getElementById('ldcBudgetShape');
    if (budgetShapeSel) {
      budgetShapeSel.addEventListener('change', function () {
        if (budgetResults && !budgetResults.hidden) regenerateBudget();
      });
    }
    /* 2026-09-14: always-live (brief) - stacks appear as the budget is typed,
       no "Show what it buys" button. `live` stays quiet mid-entry. Assigned to
       the IIFE-scoped `computeBudget` so restore/recompute sites can reach it. */
    computeBudget = function (live) {
      var input = document.getElementById('ldcBudgetAmount');
      var errorEl = document.getElementById('ldcBudgetError');
      var raw = input.value.trim();
      var budget = parseFloat(raw);
      errorEl.hidden = true;
      if (!raw || isNaN(budget) || budget <= 0) {
        budgetResults.hidden = true;
        lastBudgetCtx = null;
        if (!live) { errorEl.textContent = 'Please enter a budget greater than 0.'; errorEl.hidden = false; }
        return;
      }
      lastBudgetCtx = { budget: budget, rec: recommendBudget(budget, state.occasion, state.budgetTiers) };
      chosenBudgetIdx = 0;
      renderBudgetResults();
      svGa('budget_searched');
      leadCard.hidden = ldcHideLead();
      var pr = document.getElementById('ldcPrintRow');
      if (pr) pr.hidden = false;
    };
    var _budgetLiveTimer = null;
    (function () {
      var bi = document.getElementById('ldcBudgetAmount');
      if (bi) bi.addEventListener('input', function () { clearTimeout(_budgetLiveTimer); _budgetLiveTimer = setTimeout(function () { computeBudget(true); }, 220); });
      var bb = document.getElementById('ldcCalcBudgetBtn');
      if (bb) bb.style.display = 'none';   /* button retired by always-live */
    })();
    budgetResults.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.ldc-combo-use') : null;
      if (!btn || !lastBudgetCtx) return;
      var idx = parseInt(btn.getAttribute('data-use-combo'), 10);
      var combo = lastBudgetCtx.rec.combos[idx];
      if (!combo) return;
      chosenBudgetIdx = idx;
      budgetPicked = true;   /* r99 */
      var tiers = combo.sizes.map(function (s) { return { shape: searchShape(), size: s, height: combo.height || 4 }; });
      var scoped = servingBooking && window.LdCakeFile;
      renderBudgetResults();
      if (scoped) {
        var host = budgetResults.querySelector('.ldc-cc[data-combo="' + idx + '"]') ||
                   budgetResults.querySelector('.ldc-cc.is-chosen') || budgetResults;
        /* the ONE scoped-save implementation (the core), with budget's
           own GA label and this results panel's redraw/rehost */
        CORE.wireScopedSave(host, tiers, {
          booking: servingBooking,
          from: 'serving',
          ga: function () { svGa('budget_stack_saved'); },
          onSaved: function () { renderBudgetResults(); },
          rehost: function () {
            return budgetResults.querySelector('.ldc-cc.is-chosen') || budgetResults;
          },
          navAfterSave: function () { return document.getElementById('ldc-cakechip-row'); }
        });
      } else {
        /* unscoped: the redraw above already wrote the scratch slot for
           the pick (same contract as guest mode) */
        svGa('budget_stack_saved');
      }
    });
  }

  /* The shared cake: Structure, Batch Math, Pricing and the Planner read
     the same key, so a cake sized here never needs retyping. Hearts travel
     as rounds (same width) for the structural tools. The contract's tier
     order is BASE FIRST — sort largest-first on write, or Structure reads
     the stack upside down.
     CONTRACT v2 (2026-07-09, the Serving→Batch-Math mismatch fix):
     stamped { tiers, at, from } written to BOTH localStorage (cross-tab,
     survives overnight) and sessionStorage (legacy readers during the
     staggered deploy). Readers adopt the newest stamp — the latest edit
     anywhere in the suite wins, no tool clobbers another. */
  /* ---- the shared Cake Chip (§3.1): "show, don't tell" — the chip at the
     top updates the moment Serving saves the cake, replacing a one-time
     text announcement with a persistent identity object. Driven from
     Serving's own tiers so it can never disagree with the tool. ---- */
  /* ---- client-file scope (Client File & Quote Engine §2.1/§4.5) ----
     Serving is the pipeline's birth-point: sized from an inquiry's guest
     count, the chosen stack saves onto the client file as its tier spec.
     Arriving with ?booking=<id> (the Planner tracker's "Size" segment, or the
     client picker) scopes this tool to that file. */
  var BOOKINGS_KEY = 'layerd-academy-bookings';
  var servingBooking = (function () {
    /* Toolkit Fix 01: scope resolution lives in the shared cake-file layer —
       an explicit ?booking= link wins (and sets the global pointer); a plain
       visit keeps the client picked anywhere in the suite. */
    if (window.LdCakeFile) return window.LdCakeFile.resolveScope();
    var m = location.search.match(/[?&]booking=([^&]+)/);
    if (!m) return null;
    var id; try { id = decodeURIComponent(m[1]); } catch (e) { id = m[1]; }
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === id) return v.bookings[i];
    } catch (e) { /* private mode / corrupt */ }
    return null;
  })();
  /* Budget build (2026-08-21): the Pro door under budget results */
  function svPricingUrl() {
    var tabs = document.querySelectorAll('.learn-subnav__tab');
    var href = '/pages/pricing';
    for (var i = 0; i < tabs.length; i++) {
      var h = tabs[i].getAttribute('href') || '';
      if (/pricing/i.test(h)) { href = h; break; }
    }
    return servingBooking
      ? href + (href.indexOf('?') >= 0 ? '&' : '?') + 'booking=' + encodeURIComponent(servingBooking.id)
      : href;
  }
  function svPlannerUrl() {
    var a = document.querySelector('.learn-subnav__tab--flagship');
    return (a && a.getAttribute('href')) || '/pages/planner';
  }
  function svGaTier() {
    var host = document.querySelector('[data-lh-tier]');
    var t = host && host.getAttribute('data-lh-tier');
    /* 2026-09-14 FIX (Mariya): Academy members carry data-lh-tier="academy",
       which this used to drop to 'visitor' - so the budget results treated a
       paying Academy (or Pro) member as free (the "upgrade to Pro" line, no
       member path). Academy includes Toolkit Pro, so it reads as premium here.
       Matches window.LAYERD.components.isMember(), which counts both. */
    if (t === 'academy') return 'premium';
    return (t === 'free' || t === 'premium' || t === 'visitor') ? t : 'visitor';
  }
  function svGa(type) {
    try { if (window.lhTrack) window.lhTrack('learn_hub_cta_clicked', { tool_name: 'serving', cta_type: type, user_tier: svGaTier() }); } catch (e) { }
  }
  /* write the chosen stack onto the file's cake (Toolkit Fix 01): geometry
     through LdCakeFile.writeCake, which preserves per-tier layers/flavour,
     keeps comboAssignments aligned and stamps provenance. The legacy direct
     write remains only for the no-helper fallback. */
  function saveStackToBooking(tiers) {
    if (!servingBooking) return null;
    if (window.LdCakeFile) {
      var geo = tiers.slice().sort(function (a, b) { return b.size - a.size; })
        .map(function (t) { return { d: t.size, h: t.height || 4, shape: t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round' }; });
      var res = window.LdCakeFile.writeCake(geo, 'serving');
      return res ? { ok: true, n: geo.length } : null;
    }
    try {
      var v = JSON.parse(localStorage.getItem(BOOKINGS_KEY));
      if (!v || (v.v !== 1 && v.v !== 2) || !v.bookings) return null;
      var bk = null;
      for (var i = 0; i < v.bookings.length; i++) if (v.bookings[i].id === servingBooking.id) { bk = v.bookings[i]; break; }
      if (!bk) return null;
      var ordered = tiers.slice().sort(function (a, b) { return b.size - a.size; });
      var prev = Array.isArray(bk.tierSpec) ? bk.tierSpec : [];
      bk.tierSpec = ordered.map(function (t, i) {
        /* r42: carry `faux` through, exactly as flavour and layers are.
           This function REWRITES tierSpec, so anything it forgets to copy
           is silently destroyed — re-saving a size here would have wiped
           every faux mark on the file. */
        return { d: t.size, layers: (prev[i] && prev[i].layers) || 3,
                 flavour: (prev[i] && prev[i].flavour) || '',
                 faux: !!(prev[i] && prev[i].faux) };
      });
      bk.tiers = ordered.length;
      localStorage.setItem(BOOKINGS_KEY, JSON.stringify(v));
      return { ok: true, n: ordered.length };
    } catch (e) { return null; }
  }
  function wireSaveStack(container, tiers) {
    if (!servingBooking) return;
    var name = (servingBooking.name || '').trim() || 'this file';
    var wrap = document.createElement('div');
    wrap.className = 'ldc-savestack';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ld-btn ld-btn--primary ldc-fw ldc-savestack__btn';
    btn.textContent = 'Save this stack to ' + name;
    var done = document.createElement('div');
    done.className = 'ldc-savestack__done';
    done.hidden = true;
    btn.addEventListener('click', function () {
      var res = saveStackToBooking(tiers);
      if (!res) { btn.textContent = 'Couldn’t save, please try again'; return; }
      svGa('stack_saved');
      btn.hidden = true;
      done.innerHTML = '';
      var ok = document.createElement('span');
      ok.className = 'ldc-savestack__ok';
      ok.textContent = 'Saved to ' + name + ' ✓';
      var a = document.createElement('a');
      a.className = 'ldc-savestack__back';
      a.href = svPlannerUrl() + '?file=' + encodeURIComponent(servingBooking.id);
      a.textContent = 'Back to ' + name + '’s file →';
      done.appendChild(ok);
      done.appendChild(a);
      done.hidden = false;
    });
    wrap.appendChild(btn);
    wrap.appendChild(done);
    container.appendChild(wrap);
  }

  /* Toolkit Fix 01 §3.3 — the two-option choice while a client is active:
     "Update [name]'s file" (writeCake, the default) vs "This calculation
     only" (the scratch slot; the file untouched). Asked once per client per
     page-session; the remembered choice applies quietly after that, with a
     one-tap "change" to re-ask. */
  /* The flow itself (file vs this-calculation-only, the P3-6 ?booking=
     default, the r17 redraw-then-note order) is the CORE's now -- ONE
     implementation shared with the Pricing budget section. This page
     hands it its specifics. */
  function wireScopedSave(container, tiers) {
    CORE.wireScopedSave(container, tiers, {
      booking: servingBooking,
      from: 'serving',
      /* r151: read at save time, not at wire time - she can flip the
         pills between seeing the cards and picking one. */
      occasion: function () { return state.occasion; },
      ga: svGa,
      /* r17: redraw the choices now that the file HAS a cake, so the card
         she picked finally shows its tick -- the redraw runs before the
         note, so the note lands in the fresh card (core hostNow). */
      onSaved: function () { renderGuestResults(); },
      /* P3-6: where the note re-mounts if the redraw swept its host away */
      rehost: function () {
        var results = document.getElementById('ldcGuestsResults');
        return results && (results.querySelector('.ldc-cc.is-chosen') || results);
      },
      /* functional-jump rule: the PIPEBAR is the post-save target -- it
         carries "Next: ..." (round six, Mariya). */
      navAfterSave: function () { return document.getElementById('ldc-cakechip-row'); }
    });
  }

  var CHIP_ORIGINS = { serving: 'Serving', structure: 'Structure', 'batch-math': 'Batch Math', pricing: 'Pricing', planner: 'the Planner', timeline: 'the Planner' };
  function servingChipSummary(tiers) {
    var ts = tiers.slice().sort(function (a, b) { return (b.size || 0) - (a.size || 0); });
    var sizes = ts.map(function (t) { return sizeLabel(t.size); }).join(' + ');
    var shp = {};
    ts.forEach(function (t) { shp[t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round'] = 1; });
    var keys = Object.keys(shp);
    return sizes + ' · ' + (keys.length === 1 ? keys[0] : 'mixed shapes');
  }
  function driveServingChip(tiers, origin) {
    var mount = document.getElementById('ldc-cakechip');
    if (!mount || !tiers || !tiers.length) return;
    var C0 = window.LAYERD && window.LAYERD.components;
    /* scoped to a client file → the chip shows the client (name · date ·
       status) with the tier summary beneath (§4.5) */
    if (servingBooking && C0 && C0.setClientChip) {
      var rowc = document.getElementById('ldc-cakechip-row'); if (rowc) rowc.hidden = false;
      mount.setAttribute('data-ld-target', '#ldc-clientpick');
      C0.setClientChip(mount, servingBooking, servingChipSummary(tiers));
      return;
    }
    /* set the attributes directly so this works even before the shared
       component script has loaded (its own DOMContentLoaded pass reads
       them); refresh live once it's available. */
    mount.setAttribute('data-ld-summary', servingChipSummary(tiers));
    mount.setAttribute('data-ld-origin', origin || 'your cake');
    var row = document.getElementById('ldc-cakechip-row');
    if (row) row.hidden = false;   /* the chip APPEARS once there's a cake (§4.1) */
    var C = window.LAYERD && window.LAYERD.components;
    if (C && C.refreshCakeChips) C.refreshCakeChips();
  }

  function saveSharedCake(tiers) {
    /* Toolkit Fix 01: a client is active → the booking record is the only
       cake destination, and it is written ONLY through the explicit
       "Update [name]'s file" choice (wireScopedSave → writeCake). This
       legacy scratch write must not fire scoped — an auto-written slot
       tagged to the client could later be adopted by a re-migration as
       tiers the baker never confirmed (found 2026-07-16, guest-calc path). */
    if (servingBooking && window.LdCakeFile) return false;
    var ordered = tiers.slice().sort(function (a, b) { return b.size - a.size; });
    /* tag the shared cake with the client it belongs to (null = unscoped), so
       a custom entry here can never shadow another client's saved tiers
       (2026-07-15 shared-cake scope fix). */
    var payload = JSON.stringify({
      /* r154: the slot says how the cake is sliced, not just its sizes -
         the chip's start-a-file flow adopts this whole object, and without
         the occasion every file it created defaulted to wedding (her
         26-vs-wedding repro). Same field writeScratch has carried since
         r151. */
      occasion: state.occasion === 'party' ? 'party' : 'wedding',
      tiers: ordered.map(function (t) {
        return { d: t.size, h: t.height || 4, shape: t.shape === 'square' ? 'square' : t.shape === 'heart' ? 'heart' : 'round' };
      }),
      at: Date.now(), from: 'serving', bookingId: (typeof servingBooking !== 'undefined' && servingBooking) ? servingBooking.id : null
    });
    var ok = false;
    try { localStorage.setItem('layerd-learn-tiers', payload); ok = true; } catch (e) { }
    try { sessionStorage.setItem('layerd-learn-tiers', payload); ok = true; } catch (e) { }
    if (ok) {
      driveServingChip(tiers, 'saved, synced to your LAYER’D Toolkit');
      try { window.dispatchEvent(new Event('layerd:cake-updated')); } catch (e) { }
    }
    return ok;
  }
  /* r51: the four-tool roll call ("Structure, Batch Math, Pricing & the
     Planner will pick it up") was recited here AND in the start-file card
     below it. The fact that matters is "saved, and it travels" — one
     clause. The enumeration teaches nothing the pipeline bar doesn't. */
  function sharedNote(prefix, bare) {
    return '<p class="ldc-shared-note">' + prefix + (bare ? '' : '. The other Toolkit tools pick it up.') + '</p>';
  }

  /* The suite lead (Mariya, 2026-07-17): an unscoped result is not a dead
     end. Serving is the free front door — offer to start an inquiry file
     right here, adopt the cake just sized, and the pipeline bar appears
     up top selling the rest of the flow (locked steps carry their own
     upgrade CTAs). */
  function startFileHtml() {
    if (!window.LdCakeFile || !window.LdCakeFile.createInquiry) return '';
    /* r201: LEAK 2. Serving is the free front door and this callout
       renders on every unscoped result, with no tier check - the second
       way a free member could hold more than one client file. At the cap
       the offer replaces the form. Serving itself stays free and
       ungated; only the file it would create is capped. */
    var Fc = window.LdCakeFile;
    if (Fc.atCap && Fc.atCap()) {
      return '<div class="ld-callout ldc-startfile">' +
        '<span class="ld-callout__label">One file at a time</span>' +
        '<p class="ldc-startfile__p">Your free client file is in use. Delete it to start another, ' +
        'or keep every inquiry open at once with ' +
        '<a href="/pages/toolkit">LAYER\u2019D Toolkit Pro</a>.</p>' +
        '</div>';
    }
    /* r51: the old paragraph recited the whole pipeline ("serving size
       through structure, flavours and batch math to the final quote") \u00b7
       the third telling on one screen. One sentence carries the offer.
       r51 also closes an r44 gap: this was a FOURTH file-creation door
       still skipping the event date \u00b7 files born here arrived at Confirm
       booking blocked, with no memory of ever having been asked. */
    return '<div class="ld-callout ldc-startfile">' +
      '<span class="ld-callout__label">Planning this for a real inquiry?</span>' +
      '<p class="ldc-startfile__p">Start a client file. This cake and every step to the final quote, saved in one place.</p>' +
      '<div class="ldc-startfile__row">' +
        '<input class="ldc-startfile__name" type="text" maxlength="60" placeholder="Client or event name" aria-label="Client or event name">' +
        '<input class="ldc-startfile__date" type="date" aria-label="Event date">' +
        '<button type="button" class="ld-btn ld-btn--primary ldc-startfile__go">Start the inquiry</button>' +
      '</div></div>';
  }
  function wireStartFile(container, getTiers) {
    var box = container.querySelector('.ldc-startfile');
    if (!box) return;
    var go = box.querySelector('.ldc-startfile__go');
    var nameI = box.querySelector('.ldc-startfile__name');
    go.addEventListener('click', function () {
      var F = window.LdCakeFile;
      if (!F || !F.createInquiry) return;
      var nm = nameI.value.trim();
      if (!nm) { nameI.setAttribute('placeholder', 'Give the inquiry a name first'); nameI.focus(); return; }
      var dateI = box.querySelector('.ldc-startfile__date');
      var dt = dateI ? (dateI.value || '').trim() : '';
      if (!dt) { go.textContent = 'Add the event date first'; if (dateI) { dateI.classList.add('is-missing'); try { dateI.focus(); } catch (e) { } } return; }
      var b = F.createInquiry(nm, 'serving', { date: dt });
      if (!b) { go.textContent = 'Couldn\u2019t start the file. Try again'; return; }
      var tiers = getTiers();
      if (tiers && tiers.length) {
        /* store contract: BASE FIRST — same largest-first order geo() uses
           for the scoped save, or Structure reads the stack upside-down */
        /* r154: a file started from this page is sliced the way this page
           is set - the create path was the last one not carrying it */
        F.writeCake(tiers.slice().sort(function (a, b) { return b.size - a.size; })
          .map(function (t) { return { d: t.size, h: t.height || 4, shape: t.shape }; }), 'serving',
          { occasion: state.occasion });
      }
      /* the page is scoped from here on — later stack picks go through the
         explicit update-the-file flow, not the scratch slot */
      servingBooking = F.getActiveBooking();
      /* r224 (Mariya: remove pipeline redirects outside the client chip). The
         "Next: Structure" link here competed with the chip for what comes next;
         the card already points at it ("the bar up top now tracks every step")
         and the code scrolls there, so the chip is the one place the pipeline
         advances. */
      box.classList.add('ldc-startfile--done');
      box.innerHTML = '<span class="ld-callout__label">File started \u2713</span>' +
        '<p class="ldc-startfile__p">' + nm.replace(/</g, '&lt;') + '\u2019s cake is saved to its file. The bar up top now tracks every step.</p>';
      try {
        var host = document.querySelector('[data-lh-tier]');
        if (window.lhTrack) window.lhTrack('learn_hub_cta_clicked', { tool_name: 'serving', cta_type: 'file_started_serving', user_tier: (host && host.getAttribute('data-lh-tier')) || 'visitor' });
      } catch (e) { }
      /* functional-jump rule (2026-07-20): the new file's pipeline bar has
         just appeared up top — carry the user to it */
      setTimeout(function () {
        ldNav(document.getElementById('ldc-cakechip-row'));
      }, 120);
    });
  }

  /* ======================= SURVIVING THE FORM POST =======================
     The lead form is a native Shopify customer form — submitting it
     reloads the page, which used to wipe the visitor's results (the old
     Custom Liquid just apologised for it in the thank-you note). Fix:
     snapshot the calculator's inputs the moment the form submits, and on
     the next load restore them and re-run the same calculation — so the
     thank-you appears right below the plan it references. Also covers
     the form-error reload. sessionStorage, one-shot. */
  var SNAP_KEY = 'layerd-serving-snapshot';

  function snapshotState() {
    var rows = [];
    tierRowsEl.querySelectorAll('.ldc-tier-row').forEach(function (row) {
      rows.push({
        shape: row.querySelector('.ldc-tier-shape').value,
        size: row.querySelector('.ldc-tier-size').value,
        height: row.querySelector('.ldc-tier-height').value
      });
    });
    return {
      v: 1,
      mode: state.mode || 'guests',
      occasion: state.occasion,
      guestTiers: state.guestTiers,
      guests: document.getElementById('ldcGuestCount').value,
      otherDesserts: document.getElementById('ldcOtherDesserts').checked,
      budget: (document.getElementById('ldcBudgetAmount') || {}).value || '',
      budgetBand: state.budgetBand,
      budgetTiers: state.budgetTiers,
      tiers: rows
    };
  }

  (function restoreAfterPost() {
    var snap = null;
    try {
      snap = JSON.parse(sessionStorage.getItem(SNAP_KEY));
      sessionStorage.removeItem(SNAP_KEY);      /* one-shot */
    } catch (e) { snap = null; }
    if (!snap || snap.v !== 1) return;

    state.occasion = snap.occasion === 'party' ? 'party' : 'wedding';
    root.querySelectorAll('.ld-chip[data-occasion]').forEach(function (b) {
      var active = b.getAttribute('data-occasion') === state.occasion;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });
    updateSliceHints();
    /* pre-2026-07-29 snapshots carry guestHeight — ignored now (the
       height select is gone); guestTiers restores when present */
    state.guestTiers = parseInt(snap.guestTiers, 10) || 0;
    if (guestTiersSel) guestTiersSel.value = state.guestTiers ? String(state.guestTiers) : '';
    /* Budget build: the third mode restores too */
    state.budgetBand = snap.budgetBand === 'fondant' ? 'fondant' : 'simple';
    state.budgetTiers = parseInt(snap.budgetTiers, 10) || 0;
    var snapBudgetSel = document.getElementById('ldcBudgetTiers');
    if (snapBudgetSel) snapBudgetSel.value = state.budgetTiers ? String(state.budgetTiers) : '';
    try { paintBudgetBands(); } catch (ePb) { }

    if (snap.mode === 'budget') {
      var bmBtn = root.querySelector('.ldc-mode-btn[data-mode="budget"]');
      if (bmBtn) bmBtn.click();
      var bIn = document.getElementById('ldcBudgetAmount');
      if (bIn) bIn.value = snap.budget || '';
      if (snap.budget) {
        computeBudget(true);
      }
    } else if (snap.mode === 'tiers') {
      tierRowsEl.innerHTML = '';
      (snap.tiers && snap.tiers.length ? snap.tiers : [null]).forEach(function (t) {
        addTierRow();
        if (!t) return;
        var row = tierRowsEl.lastElementChild;
        var ss = row.querySelector('.ldc-tier-shape');
        ss.value = t.shape;
        ss.dispatchEvent(new Event('change'));  /* repopulate sizes for the shape */
        row.querySelector('.ldc-tier-size').value = t.size;
        row.querySelector('.ldc-tier-height').value = t.height;
      });
      var tiersBtn = root.querySelector('.ldc-mode-btn[data-mode="tiers"]');
      if (tiersBtn) tiersBtn.click();
      if (snap.tiers && snap.tiers.length) computeTiers(true);
    } else {
      document.getElementById('ldcGuestCount').value = snap.guests || '';
      document.getElementById('ldcOtherDesserts').checked = !!snap.otherDesserts;
      if (snap.guests) computeGuests(true);
    }
    /* the post-back thank-you scrolled into view at parse time, before the
       results re-rendered above it — bring it back into view now. */
    var joined = document.getElementById('ldc-joined');
    if (joined) ldNav(joined, { block: 'center' });
  })();

  var snapForm = document.getElementById('ldc-lead-form') ||
                 document.querySelector('.ldc-lead form');
  if (snapForm) {
    snapForm.addEventListener('submit', function () {
      try { sessionStorage.setItem(SNAP_KEY, JSON.stringify(snapshotState())); } catch (e) { /* private mode */ }
    });
  }

  /* ======================= LEAD CAPTURE v3 (list only, honest copy) ======================= */

  var printBtn = document.getElementById('ldcPrintBtn');
  if (printBtn) {
    printBtn.addEventListener('click', function () {
      /* r192: the composed serving plan prints itself, from its own
         document (learn-serving-plan.js). It has to be CALLED, not
         raced: a listener that file adds to this same button cannot run
         first, because at the event's own target the capture flag is
         ignored and listeners fire in registration order - and this file
         loads first by contract. That race is why the Pro printout came
         out blank while the free preview was fine.
         Returns false (or the file is absent) -> the old behaviour. */
      var P = window.LAYERD && window.LAYERD.servingPlanPrint;
      try { if (P && P.print && P.print()) return; } catch (e) { }
      window.print();
    });
  }

  /* v3 (2026-08-12): the ORIGINAL capture, copy reworded to promise only
     the list. No plan-email call here — that build is SHELVED (see
     learn-hub/docs/flow-serving-plan-email.md); if revived, its v2 code
     replaces this block. The id lives on the Liquid form tag, which the
     preview builder swaps for a bare <form> — the class fallback keeps
     the preview exercising this block. */
  var leadForm = document.getElementById('ldc-lead-form') ||
                 document.querySelector('.ldc-lead form');
  if (leadForm) {
    var tagsInput = document.getElementById('ldcTags');
    var waitlistCheck = document.getElementById('ldcWaitlist');

    function syncTags() {
      if (!tagsInput) return;
      tagsInput.value = 'cake-calculator' + (waitlistCheck && waitlistCheck.checked ? ',academy-waitlist' : '');
    }
    if (waitlistCheck) waitlistCheck.addEventListener('change', syncTags);
    syncTags();

    leadForm.addEventListener('submit', function (e) {
      var hp = document.getElementById('ldc-web');
      if (hp && hp.value.trim() !== '') { e.preventDefault(); return false; }
    });
  }

  /* ============ UNITS TOGGLE ============ */
  // Flip re-labels the size selects and re-renders showing results (they
  // carry size labels); values, math and the shared cake stay inches.
  var unitBtns = root.querySelectorAll('.ldc-units-btn');
  var guestsResults = document.getElementById('ldcGuestsResults');
  var tiersResults = document.getElementById('ldcTiersResults');
  unitBtns.forEach(function (btn) {
    if (btn.getAttribute('data-unit') === unitPref()) btn.classList.add('is-active');
    btn.addEventListener('click', function () {
      try { localStorage.setItem(UNITS_KEY, btn.getAttribute('data-unit')); } catch (e) { /* private mode */ }
      unitBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      relabelTierRows();
      if (guestsResults && !guestsResults.hidden) computeGuests(true);
      if (tiersResults && !tiersResults.hidden) computeTiers(true);
      if (budgetResults && !budgetResults.hidden) computeBudget(true);
    });
  });

  /* on load, show any cake the suite already knows — so the chip reflects
     a cake sized elsewhere (or in a past visit) before the user calculates.
     Runs LAST, after CHIP_ORIGINS + driveServingChip are assigned, so a
     cross-tool cake (e.g. from Structure) can't throw and halt init. */
  (function bootServingChip() {
    var best = null;
    [localStorage, sessionStorage].forEach(function (store) {
      try {
        var v = JSON.parse(store.getItem('layerd-learn-tiers'));
        if (v && v.tiers && v.tiers.length && (!best || (v.at || 1) > (best.at || 1))) best = v;
      } catch (e) { /* private mode */ }
    });
    /* Choose the tier SOURCE by client scope (2026-07-15 shared-cake fix):
       - scoped to a client → the shared cake ONLY if it's that client's
         working cake; otherwise the client's SAVED tierSpec (the Planner is
         the source of truth), so another cake never shadows it.
       - unscoped → the shared cake only if it's unscoped too. */
    var scopeBid = (typeof servingBooking !== 'undefined' && servingBooking) ? servingBooking.id : null;
    var sharedBid = (best && best.bookingId !== undefined) ? (best.bookingId || null) : null;
    var seedTiers = null, origin = 'your saved cake', seededFromFile = false;
    function fromShared() {
      origin = best.from === 'serving' ? 'your saved cake'
        : (CHIP_ORIGINS[best.from] ? 'from ' + CHIP_ORIGINS[best.from] : 'your saved cake');
      return best.tiers;
    }
    if (scopeBid && window.LdCakeFile) {
      /* Toolkit Fix 01: the BOOKING RECORD is the source of truth. A cake
         explicitly set on the file seeds the form; a preset-derived one
         (never set) leaves the default row so nobody mistakes placeholder
         sizes for the client's real cake — Serving is where they get set. */
      var rc = window.LdCakeFile.readCake();
      if (rc.source === 'booking') { seedTiers = rc.tiers; origin = 'from ' + (CHIP_ORIGINS[rc.meta.updatedBy] || 'the Planner'); seededFromFile = true; }
      else {
        var hintHost = document.getElementById('ldcTiersPanel') || tierRowsEl.parentNode;
        if (hintHost && !document.getElementById('ldcNoTiersHint')) {
          var hint = document.createElement('p');
          hint.id = 'ldcNoTiersHint';
          hint.className = 'ldc-hint';
          hint.textContent = 'No tiers on ' + (((servingBooking.name || '').trim()) || 'this file') + '’s file yet, size the cake below and it saves back.';
          hintHost.insertBefore(hint, hintHost.firstChild);
        }
      }
    } else if (scopeBid) {
      if (best && sharedBid === scopeBid) { seedTiers = fromShared(); }
      else {
        /* no-helper fallback: the client's saved tiers, derived EXACTLY like
           the Planner's tierSpecOf (explicit entries win, presets pad) */
        var BP = { 1: [8], 2: [8, 6], 3: [10, 8, 6], 4: [12, 10, 8, 6], 5: [12, 10, 8, 6, 4], 6: [14, 12, 10, 8, 6, 4] };
        var spec = Array.isArray(servingBooking.tierSpec) ? servingBooking.tierSpec : [];
        var bn = Math.max(1, +servingBooking.tiers || spec.length || 2);
        var bp = BP[bn] || BP[6];
        var bh = servingBooking.tall ? 6 : 4;
        seedTiers = [];
        for (var bi = 0; bi < bn; bi++) {
          var bs = spec[bi] || {};
          seedTiers.push({ d: +bs.d || bp[bi] || 6, h: bh, shape: 'round', faux: !!bs.faux });
        }
        seedTiers.sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
        origin = 'from the Planner';
      }
    } else if (best && sharedBid === null) {
      seedTiers = fromShared();
    }
    if (!seedTiers) return;   /* leave the placeholder — the component shows its empty state */
    var tiers = seedTiers.map(function (t) { return { size: t.d, shape: t.shape }; });
    driveServingChip(tiers, origin);

    /* THE CHIP MUST NOT LIE (Mariya, 2026-07-14): showing the saved cake
       up top while the form still holds the default 4" row meant one tap
       of Calculate silently OVERWROTE the shared cake with that default.
       Seed the "I know my tiers" rows from the SAME source the chip shows,
       so what the chip shows is what the form computes — and what Calculate
       re-saves is the same cake. A shape whose size list lacks the exact
       inch snaps to the nearest available option. */
    try {
      tierRowsEl.innerHTML = '';   /* drop the untouched default row */
      tierRowCount = 0;
      seedTiers.forEach(function (t) {
        addTierRow();
        var row = tierRowsEl.lastElementChild;
        var shapeS = row.querySelector('.ldc-tier-shape');
        var sizeS = row.querySelector('.ldc-tier-size');
        var heightS = row.querySelector('.ldc-tier-height');
        var shape = (t.shape === 'square' || t.shape === 'heart') ? t.shape : 'round';
        shapeS.value = shape;
        shapeS.dispatchEvent(new Event('change'));   /* repopulate the size list */
        var opts = sizeOptionsFor(shape);
        var d = +t.d || 6, bestOpt = opts[0];
        opts.forEach(function (o) { if (Math.abs(o - d) < Math.abs(bestOpt - d)) bestOpt = o; });
        sizeS.value = String(bestOpt);
        var h = Math.min(8, Math.max(4, Math.round(+t.h || 4)));
        heightS.value = String(h);
        /* r42: a faux tier is a dummy — it serves nobody. Mark the row so
           the total below can skip it, and say so on screen rather than
           silently returning a smaller number than the tier count implies. */
        if (t.faux) {
          row.setAttribute('data-faux', '1');
          row.classList.add('is-faux');
          /* the badge is the "say so" part — without it the row looks
             identical to a real tier while contributing nothing to the
             total, which is exactly how a correct number reads as a bug.
             Guarded so a re-seed can't stack two badges on one row. */
          if (!row.querySelector('.lsv-faux')) {
            var fb = document.createElement('span');
            fb.className = 'lsv-faux';
            fb.textContent = 'faux';
            fb.title = 'A dummy tier, covered but never baked, so it serves nobody. Change this in Recipes.';
            row.appendChild(fb);
          }
        }
      });
    } catch (e) {
      /* seeding must never break the calculator — worst case the form
         keeps its default row and the chip still shows the saved cake */
      if (!tierRowsEl.children.length) addTierRow();
    }

    /* r174 (her test user: "he goes back to Serving and nothing from
       previously is populated"). It WAS populated - the rows were seeded
       from the file all along - but the page opens on Guest count, so the
       panel holding his cake was hidden and no result was on screen. The
       work was one tab away and invisible, which reads exactly like loss.

       So when the cake came from the FILE, open the panel it went into and
       run the calculation, the same two moves restoreAfterPost already
       makes when it comes back from a form post. Calculating writes
       nothing - saving to the file is still the explicit button - so this
       shows what he did without deciding anything for him.

       Scoped to seededFromFile on purpose: an unscoped visitor whose
       shared cake happens to be lying around should still land on the
       page's own front door. */
    if (seededFromFile) {
      try {
        var tb174 = root.querySelector('.ldc-mode-btn[data-mode="tiers"]');
        if (tb174) tb174.click();
        if (tierRowsEl.querySelectorAll('.ldc-tier-row').length) computeTiers(true);
      } catch (e174) { /* the form still holds the cake either way */ }
    }
  })();

  /* client picker (§4.5) + scope the chip to the file on load, so the moment
     you arrive from an inquiry the tool names whose cake you're sizing. */
  (function servingClientScope() {
    /* r5 (2026-07-30): the standalone client <select> is retired suite-wide —
       the shared bar owns the file list behind its "change" link. */
    var comp = window.LAYERD && window.LAYERD.components;
    if (servingBooking && comp && comp.setClientChip) {
      var mount = document.getElementById('ldc-cakechip');
      var row2 = document.getElementById('ldc-cakechip-row');
      var st = Array.isArray(servingBooking.tierSpec) ? servingBooking.tierSpec : [];
      var summ = st.length ? st.slice().sort(function (a, b) { return (b.d || 0) - (a.d || 0); })
        .map(function (t) { return (+t.d || 6) + '″'; }).join(' + ') : '';
      if (mount) {
        if (row2) row2.hidden = false;
        mount.setAttribute('data-ld-target', '#ldc-clientpick');
        comp.setClientChip(mount, servingBooking, summ);
      }
      /* r191: the round-34 #ldcPrintClient write is gone with the
         letterhead. The sheet reads the open booking itself, at print
         time — this stamped it once, at load, so a file opened or renamed
         afterwards printed the wrong name. */
      svGa('sizing_opened');
    }
  })();

  /* round twenty (Mariya): arriving from the client file's sizing banner
     (?booking=<id>&suggest=1) — the guest count carries over and the
     suggestions are already on screen. ONE engine (this page) suggests
     sizes; the file never runs its own math. The click that brought the
     user here sanctions the landing jump. */
  (function autoSuggest() {
    if (!/[?&]suggest=1/.test(location.search)) return;
    var b = window.LdCakeFile && window.LdCakeFile.getActiveBooking && window.LdCakeFile.getActiveBooking();
    if (!b || !(+b.guests > 0)) return;
    var mb = document.querySelector('.ldc-mode-btn[data-mode="guests"]');
    if (mb) mb.click();
    var gi = document.getElementById('ldcGuestCount');
    if (gi) gi.value = b.guests;
    computeGuests(true);
    setTimeout(function () {
      var res = document.getElementById('ldcGuestsResults');
      if (res && !res.hidden) ldNav(res);
    }, 160);
  })();

})();

/* ============================================================
   REDESIGN r6 (2026-07-31) — Serving: dock the units toggle into
   the compact header, and give the mode toggle its live values.
   Presentation only: the same buttons, the same listeners, the
   same engine. Values are READ from what the page rendered.
   ============================================================ */
(function initLdcHead() {
  /* r25 (2026-07-31, Mariya): the unit pills move OUT of the header and
     sit just under the client bar. In the header they competed with the
     tier badge for the same row and knocked it out of line on the pages
     that carry them. Position only - the listeners are unchanged. */
  var units = document.querySelector('.ldc-units');
  if (!units) return;
  var bar = document.querySelector('.ld-cakechip-row');
  if (bar && bar.parentNode) {
    units.classList.add('ld-unitrow');
    units.classList.add('learn-wrap');   /* r26: same wrap as the bar */
    bar.parentNode.insertBefore(units, bar.nextSibling);
    return;
  }
  var slot = document.getElementById('ldc-units-slot');   /* stale template */
  if (slot && units.parentNode !== slot) slot.appendChild(units);
})();

(function initLdcModeVals() {
  var toggle = document.querySelector('.ldc-mode-toggle');
  if (!toggle) return;
  var LBL = { guests: 'Guest count', tiers: 'My tiers', budget: 'Budget' };
  /* UX 2026-09-07 (design pass): an empty pill shows its own word, not a bare "—" that reads as broken */
  var EMPTY = { guests: 'count', tiers: 'tiers', budget: 'budget' };
  var btns = Array.prototype.slice.call(toggle.querySelectorAll('.ldc-mode-btn'));
  if (!btns.length) return;

  /* wrap each button's text once: label over value */
  btns.forEach(function (b) {
    if (b.querySelector('.ldc-mode-btn__lbl')) return;
    var key = b.getAttribute('data-mode') || '';
    b.textContent = '';
    var l = document.createElement('span');
    l.className = 'ldc-mode-btn__lbl';
    l.textContent = LBL[key] || key;
    var v = document.createElement('span');
    v.className = 'ldc-mode-btn__val';
    v.textContent = EMPTY[key] || '';
    b.appendChild(l); b.appendChild(v);
  });

  function valFor(key) {
    /* read what the page already says — never a second calculation */
    if (key === 'guests') {
      var g = document.getElementById('ldcGuestCount');
      var n = g && parseInt(g.value, 10);
      return (n > 0) ? n + (n === 1 ? ' guest' : ' guests') : EMPTY.guests;
    }
    if (key === 'budget') {
      var bA = document.getElementById('ldcBudgetAmount');
      var bv = bA && parseFloat(bA.value);
      return (bv > 0) ? '$' + Math.round(bv).toLocaleString('en-US') : EMPTY.budget;
    }
    var chip = document.querySelector('.ld-cakechip__spec');
    var m = chip && /(\d[\d,]*)\s+serving/.exec(chip.textContent || '');
    if (m) return m[1] + ' servings';
    var out = document.querySelector('.ldc-result-servings, .ldc-heroresult__n, .ldc-big');
    var t = out && (out.textContent || '').trim();
    if (t) { var mm = /(\d[\d,]*)/.exec(t); if (mm) return mm[1] + ' servings'; }
    return EMPTY.tiers;
  }
  function paint() {
    btns.forEach(function (b) {
      var v = b.querySelector('.ldc-mode-btn__val');
      if (v) v.textContent = valFor(b.getAttribute('data-mode') || '');
    });
  }
  toggle.addEventListener('click', function () { setTimeout(paint, 0); });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'ldcGuestCount') paint();
  });
  /* the results render into several different containers on this page
     (.ldc-heroresult for tiers mode, the compare cards for guests) — watch
     the whole wrap rather than guessing which one, debounced so a render
     storm repaints once. */
  var wrap = document.querySelector('.ldc-wrap') || document.body;
  var t = null;
  if (wrap) new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(paint, 60);
  }).observe(wrap, { childList: true, subtree: true, characterData: true });
  paint();
})();
